import Vue from 'vue'
import Vuex from 'vuex'
import { mainReqUrl } from '../util/mainReqUrl'
import { cityDetail } from '../util/mainOption'
import { getUserInfoByUserId } from '../api/login'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // websocket连接地址
    socketUrl: `${mainReqUrl.socketUrl}/websocket/`,
    // websocket连接
    websock: null,
    // 心跳间隔时长
    wsTimeOut: 30 * 1000,
    // websocket断开重连倒计时
    timeoutnum: null,
    // 当前是否有消息
    haveMessage: false,
    //心跳心跳倒计时
    timeoutObj: null,
    // //心跳倒计时
    serverTimeoutObj: null,
    lockReconnect: null,
    delayTime: false,
    delayTimeData: null,
    auctionBid: false,
    auctionBidData: null,
    isLogin: false,
  },
  mutations: {
    // 初始化websocket
    initWebSocket (state) {
      console.log("初始化websocket")
      if (cityDetail.startWebSocket && state.socketUrl) {
        getUserInfoByUserId().then(res => {
          let userId = res.data.data.userId
          const wsUrl = state.socketUrl + userId

          console.log('state.websock', state.websock)

          if (state.websock) {
            return // 避免重复连接
          }
          state.websock = new WebSocket(wsUrl)
          state.websock.onmessage = (msg) => { this.commit("websocketOnMessage", msg) }
          state.websock.onopen = () => { this.commit("websocketOnOpen") }
          state.websock.onerror = () => { this.commit("reconnect") }
          state.websock.onclose = () => { this.commit("websocketClose") }
          window.onbeforeunload = () => { this.commit("websocketClose") }
        })
      }
    },
    websocketOnMessage (state, message) {
      let newsData = JSON.parse(message.data)
      console.log('websocketOnMessage:', newsData)

      if (newsData.type == "notice") {
        // 通知
        state.haveMessage = true
      } else if (newsData.type == "delayTime") {
        // 顺延时间消息
        state.delayTime = true
        state.delayTimeData = newsData.data
      } else if (newsData.type == "auctionBid") {
        // 有人有新出价
        state.auctionBid = true
        state.auctionBidData = newsData.data
      } else if (newsData.type == "heartcheck") {
        //收到服务器信息，心跳重置
        clearTimeout(state.serverTimeoutObj)
        this.commit("start")
      }
    },
    websocketOnOpen (state) {
      console.log('WebSocket connected')
      this.commit("start")
    },
    reconnect (state) {
      if (state.lockReconnect) return
      state.lockReconnect = true
      state.timeoutnum = setTimeout(() => {
        //新连接
        this.commit("initWebSocket")
        state.lockReconnect = false
      }, 5000)
    },
    websocketClose (state) {
      console.log("断开连接")
      clearInterval(state.timeoutObj)
      clearTimeout(state.serverTimeoutObj)
      if (state.websock) {
        state.websock.close()
        state.websock = null
      }
      state.websock = null
    },

    start (state) { // 开启心跳
      state.timeoutObj && clearTimeout(state.timeoutObj)
      state.serverTimeoutObj && clearTimeout(state.serverTimeoutObj)
      state.timeoutObj = setTimeout(() => {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (state.websock && state.websock.readyState == 1) { // 如果连接正常
          let actions = { "cmd": "heartcheck" }
          state.websock.send(JSON.stringify(actions))
        } else { // 否则重连
          this.commit("reconnect")
        }
        state.serverTimeoutObj = setTimeout(() => {
          //超时关闭
          state.websock.close()
        }, state.wsTimeOut)

      }, state.wsTimeOut)
    },
  },
  actions: {
  },
  modules: {
  }
})
